export const getPropertyValue = (value: any, property: string) => {
   return property.split('.').reduce((r, val) => { return r ? r[val] : undefined; }, value);
}